import {batchActions} from 'redux-batch-enhancer'
import {CALL_API, Call} from 'redux/middleware/api'
// import {getCurrentSitePlease} from 'redux/modules/currentUser/actions'
import {getCurrentSite, getConverionType} from 'redux/modules/currentUser/selectors'
import {reportError} from 'redux/modules/error/actions'
import formatDateWithTz from 'utils/formatDateWithTz'
import {
  JOURNEYS,
  JOURNEYS_PER_PAGE,
  JOURNEYS_SET_SESSION_FILTER,
  JOURNEYS_SET_SESSIONS_ONLY_FILTER,
  JOURNEYS_SET_FILTER,
  JOURNEYS_RESET_FILTERS,
  JOURNEYS_RESET_ALL
} from '.'

function loadUserJourneys({
  merchantSiteId,
  targetCurrency,
  skip = 0,
  startDate,
  endDate,
  filter,
  sessions,
  conversionType,
  sessionsOnly
}) {
  const queryParams = {
    merchantSiteId
  }
  const body = {
    range: {
      start: startDate,
      end: endDate
    },
    skip,
    limit: JOURNEYS_PER_PAGE,
    filter,
    sessions,
    targetCurrency,
    sessionsOnly,
    conversionType
  }
  return {
    [CALL_API]: {
      endpoint: 'userJourneys',
      method: 'POST',
      types: JOURNEYS,
      queryParams,
      body
    }

  }
}

export function setActiveFilter(type, value) {
  return {
    type: JOURNEYS_SET_FILTER,
    filterType: type,
    filterValue: value
  }
}

export function setSessionFilter(type, value, channelTypes ) {
  return {
    type: JOURNEYS_SET_SESSION_FILTER,
    filterType: type,
    filterValue: value,
    channelTypes: channelTypes
  }
}

export function setSessionsOnlyFilter(value) {
  return {
    type: JOURNEYS_SET_SESSIONS_ONLY_FILTER,
    value
  }
}

export function resetActiveFilters() {
  return {
    type: JOURNEYS_RESET_FILTERS
  }
}

export function resetFiltersAndStats() {
  return {
    type: JOURNEYS_RESET_ALL
  }
}

export function fetchData(page = 0, startDate, endDate, currency, timezone, filter, sessions, sessionsOnly) {
  return (dispatch, getState) => {
    const state = getState()
    const {id} = getCurrentSite(state) || {}
    const conversionType = getConverionType(state)
    const fetchParams = {
      merchantSiteId: id,
      skip: JOURNEYS_PER_PAGE * page,
      startDate: formatDateWithTz(startDate, timezone),
      endDate: formatDateWithTz(endDate, timezone),
      filter,
      sessions,
      targetCurrency: currency,
      sessionsOnly,
      conversionType
    }
    Call.all(dispatch(batchActions([
      loadUserJourneys(fetchParams)
    ])))
      .fail(dispatch(reportError()))
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/aggr/actions.js